import type { Invoice } from "./types";

/** 详情页：展示金额 + 发票代码等主卡片 */
export function invoiceShowsIssuedSection(inv: Invoice): boolean {
  if (inv.invoiceUrl?.trim()) return true;
  if ((inv.invoiceCode || "").trim() && (inv.invoiceNumber || "").trim())
    return true;
  if (inv.hasIssuedMeta === true) return true;
  return false;
}

/** 详情页：底部「处理中」说明 */
export function invoiceShowsPendingBanner(inv: Invoice): boolean {
  if (inv.showPendingTip === true) return true;
  if (inv.showPendingTip === false) return false;
  return /待处理|申请中|处理中/.test(inv.status);
}

/** 列表/详情：是否展示下载入口（有链接才可真正打开） */
export function invoiceCanDownloadPdf(inv: Invoice): boolean {
  return Boolean(inv.invoiceUrl?.trim());
}

/** 列表卡片：是否显示下载按钮（仅在有 PDF 链接时） */
export function invoiceShowsDownloadButton(inv: Invoice): boolean {
  return invoiceCanDownloadPdf(inv);
}
